<template>
    <div>STUDENT OPTIMIZATION</div>
</template>

<script></script>

<style scoped></style>
